import { DocumentModel } from '../../../../shared/models/simple-types/document.model';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef, Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { validatorFileSize } from 'src/app/shared/fileValidators';
import { BpComponentsService } from '../../bp-components.service';

export interface DialogData {
  idBp: number;
  documents: DocumentModel[];
}

@Component({
  selector: 'app-modal-add-bp-document',
  templateUrl: './modal-add-bp-document.component.html',
  styleUrls: ['./modal-add-bp-document.component.scss'],
})

export class ModalAddBpDocumentComponent implements OnInit {

  public form: UntypedFormGroup;
  filename: string;
  file: File;
  progress = 0;
  ext: string;
  libelleControl: UntypedFormControl;
  fileControl: UntypedFormControl;
  result = false;
  constructor(public dialog: MatDialog,
              private toastr: ToastrService,
              public router: Router,
              private bpService: BpComponentsService,
              public dialogRef: MatDialogRef<Component>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private changeDetectorRef: ChangeDetectorRef) {
    this.libelleControl = new UntypedFormControl(null, Validators.required);
    this.fileControl = new UntypedFormControl(null, [Validators.required, validatorFileSize(16000000)]);
    this.form = new UntypedFormGroup({
      file: this.fileControl,
      libelle: this.libelleControl
    });
  }
  @HostListener('change', ['$event.target.files']) emitFiles(event: FileList) {
    const file = event && event.item(0);
    this.file = file;
  }
  ngOnInit(): void {
  }

  onModalCancel(): void {
    this.dialogRef.close(this.result);
  }

  submit(): void {
    if (this.form.valid) {
      this.file = this.fileControl.value;
      const extension = this.file.name.split('.')[1].toLowerCase();
      this.libelleControl.setValue(this.libelleControl.value.replace(/[\W_]+/g, ""));
      this.filename = this.libelleControl.value + '.' + extension;
      this.bpService.sendDocument(this.filename, this.data.idBp, this.file).subscribe((res) => {
        this.progress = res;
        if (res === 100) {
          this.result = true;
          this.toastr.success('Le fichier : ' + this.filename + ' à bien été enregistré.');
          this.form.enable();
          this.libelleControl.reset('', {emitEvent: false});
          this.libelleControl.markAsUntouched();
          this.fileControl.reset('', {emitEvent: false});
          this.fileControl.markAsUntouched();
          this.changeDetectorRef.detectChanges();
          this.dialogRef.close(this.result);
        } else if (res === -1) {
          this.progress = 0;
          this.form.enable();
          this.toastr.warning('Le fichier : ' + this.filename + ' éxiste déjà pour ce bp');
        } else {
          this.form.disable();
        }
      }, (error: any) => {
      });
    }
  }
}
